import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "card p-0",
  id: "uploadedPdfTemplate"
}
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table mb-0 table-shadowed" }
const _hoisted_5 = { class: "table-primary text-nowrap" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { href: "javascript:void(0)" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt mx-2" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "table-button" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-stop-circle" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Send")
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-circle" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Show")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "table-button" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-circle" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Continious Digitize")
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-circle" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Show")
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-pen-circle" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { colspan: 5 }
const _hoisted_27 = { class: "modal-wrap" }
const _hoisted_28 = {
  class: "modal fade",
  id: "sendDocument",
  tabindex: "-1",
  "aria-labelledby": "sendDocument",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Send Doucment "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_34 = { class: "modal-body" }
const _hoisted_35 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_36 = { class: "form-wrap pt-0" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "contract Title", -1)
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite Existing member", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("option", { disabled: "" }, "Select the member", -1)
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Message", -1)
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = { class: "modal-wrap default-modal" }
const _hoisted_48 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "deleteModalLabel"
}, "Delete Document", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-danger mb-0",
    role: "alert"
  }, " Are you sure ? You want to delete the document. ")
], -1)
const _hoisted_55 = { class: "modal-footer" }
const _hoisted_56 = { class: "modal-wrap" }
const _hoisted_57 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-1000" }
const _hoisted_59 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_60 = {
  key: 1,
  class: "modal-content  mh-auto"
}
const _hoisted_61 = { class: "modal-header" }
const _hoisted_62 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_64 = { class: "modal-body" }
const _hoisted_65 = { class: "responsive-iframe-wrap docu-iframe" }
const _hoisted_66 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isPostLoading.sendDocument)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("img", {
            src: 
                _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                    : 'img/loading.gif'
            ,
            alt: ""
          }, null, 8, ["src"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("table", _hoisted_4, [
              _createVNode("thead", _hoisted_5, [
                _createVNode("tr", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.heading, (header, headerIndex) => {
                    return (_openBlock(), _createBlock("th", {
                      scope: "col",
                      key: headerIndex
                    }, _toDisplayString(header.name), 1))
                  }), 128))
                ])
              ]),
              (
                       _ctx.state.data.documentList.length)
                ? (_openBlock(), _createBlock("tbody", _hoisted_6, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.documentList, (document, documentIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                        _createVNode("td", null, [
                          _createVNode("p", null, [
                            _createVNode("a", _hoisted_7, [
                              _createTextVNode(_toDisplayString(document.name) + " ", 1),
                              _hoisted_8
                            ])
                          ])
                        ]),
                        (_ctx.from == 'DocumentListModel')
                          ? (_openBlock(), _createBlock("td", _hoisted_9, [
                              _createVNode("div", _hoisted_10, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn default-btn mr-1",
                                  onClick: ($event: any) => (_ctx.showSentDocusignDocumentModel(document))
                                }, [
                                  _hoisted_11,
                                  _hoisted_12
                                ], 8, ["onClick"]),
                                _createVNode("a", {
                                  href: document.url,
                                  target: "_blank",
                                  class: "btn blue-btn mr-1"
                                }, [
                                  _hoisted_13,
                                  _hoisted_14
                                ], 8, ["href"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("td", _hoisted_15, [
                              _createVNode("div", _hoisted_16, [
                                (document.status==1)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      href: "javascript:void(0)",
                                      class: "btn default-btn mr-1",
                                      onClick: ($event: any) => (_ctx.editEnvelopeDocument(document.uuid))
                                    }, [
                                      _hoisted_17,
                                      _hoisted_18
                                    ], 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (document.status==0)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 1,
                                      href: "javascript:void(0)",
                                      class: "btn default-btn mr-1",
                                      onClick: ($event: any) => (_ctx.editEnvelopeDocument(document.uuid))
                                    }, [
                                      _hoisted_19,
                                      _hoisted_20
                                    ], 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (document.status==1)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 2,
                                      href: "javascript:void(0)",
                                      class: "btn blue-btn mr-1",
                                      onClick: ($event: any) => (_ctx.docusignTempleteDetails(document.uuid))
                                    }, [
                                      _hoisted_21,
                                      _hoisted_22
                                    ], 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn red-btn mr-1",
                                  onClick: ($event: any) => (_ctx.openDocumentDeleteModel(document.uuid))
                                }, [
                                  _hoisted_23,
                                  _hoisted_24
                                ], 8, ["onClick"])
                              ])
                            ]))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("tfoot", _hoisted_25, [
                    _createVNode("tr", null, [
                      _createVNode("td", _hoisted_26, [
                        _createVNode(_component_EmptyData, {
                          title: _ctx.state.data.title,
                          heading: _ctx.state.data.heading
                        }, null, 8, ["title", "heading"])
                      ])
                    ])
                  ]))
            ])
          ])
        ])),
    _createVNode("div", _hoisted_27, [
      _createVNode("div", _hoisted_28, [
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideDocusignDocumentModel && _ctx.hideDocusignDocumentModel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_33
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              (_ctx.state.ui.isPostLoading.sendDocument)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _createVNode("img", {
                      src: 
                                    _ctx.state.data.imageBaseUrl
                                        ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                                        : 'img/loading.gif'
                                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_36, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.error.errorList.sendDocusignDocument,
                  hasError: _ctx.state.ui.error.hasError
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _withDirectives(_createVNode("input", {
                      id: "titleOfForm",
                      type: "text",
                      class: 'form-control',
                      placeholder: "contract document title",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.sendData.title = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.sendData.title]
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createVNode("select", {
                      disabled: _ctx.state.newMemberList && !_ctx.state.newMemberList.length,
                      class: "form-control mb-2",
                      id: "user.id",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.existingMember = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMember && _ctx.changeExistingMember(...args)))
                    }, [
                      _hoisted_41,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.newMemberList, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: item.user,
                          key: itemIndex
                        }, _toDisplayString(item.user.full_name) + " (" + _toDisplayString(item.user.email) + ") ", 9, ["value"]))
                      }), 128))
                    ], 40, ["disabled"]), [
                      [_vModelSelect, _ctx.state.existingMember]
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.documentSentUser, (user, userIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "email-tag",
                        key: userIndex
                      }, [
                        _createVNode("p", _hoisted_42, [
                          _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                          }, [
                            _hoisted_43
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _withDirectives(_createVNode("textarea", {
                      rows: "5",
                      id: "titleOfForm",
                      class: 'form-control h-auto',
                      placeholder: "Message",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.sendData.message = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.sendData.message]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_46, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createEvelopeDocument && _ctx.createEvelopeDocument(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.sendDocument
                                ? "Sending..."
                                : "Send"), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_47, [
      _createVNode("div", _hoisted_48, [
        _createVNode("div", _hoisted_49, [
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _hoisted_52,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDocumebntDeleteModal && _ctx.closeDocumebntDeleteModal(...args))),
                "aria-label": "Close",
                disabled: _ctx.state.ui.isPostLoading.deleteClientDocument
              }, [
                _hoisted_53
              ], 8, ["disabled"])
            ]),
            _hoisted_54,
            _createVNode("div", _hoisted_55, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteDocuignDocument && _ctx.deleteDocuignDocument(...args))),
                disabled: _ctx.state.ui.isPostLoading.deleteClientDocument
              }, _toDisplayString(_ctx.state.ui.isPostLoading.deleteClientDocument ? "loading..." : "Delete"), 9, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDocumebntDeleteModal && _ctx.closeDocumebntDeleteModal(...args))),
                disabled: _ctx.state.ui.isPostLoading.deleteClientDocument
              }, " No ", 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_56, [
      _createVNode("div", _hoisted_57, [
        _createVNode("div", _hoisted_58, [
          (_ctx.state.ui.isLoading.showDocument)
            ? (_openBlock(), _createBlock("div", _hoisted_59, [
                _createVNode("img", {
                  src: 
                _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                    : 'img/loading.gif'
            ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_60, [
                _createVNode("div", _hoisted_61, [
                  _createVNode("h5", _hoisted_62, _toDisplayString(_ctx.state.data.selectDocument.email_subject), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentDetails && _ctx.closeDocumentDetails(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_63
                  ])
                ]),
                _createVNode("div", _hoisted_64, [
                  _createVNode("div", _hoisted_65, [
                    _createVNode("iframe", {
                      id: "myIframe",
                      src: _ctx.state.data.selectDocument.url,
                      name: "myFrame",
                      frameborder: "0",
                      scrolling: "no"
                    }, null, 8, ["src"])
                  ])
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentDetails && _ctx.closeDocumentDetails(...args)))
                  }, " Close ")
                ])
              ]))
        ])
      ])
    ])
  ]))
}